import { Button, Icon } from '@platform/components';
import { ROUTES } from '../../../routes/consts';

export const CommunityBackButton = () => {
  return (
    <div className='w-full flex justify-left'>
      <Button
        href={`platform${ROUTES.DASHBOARD}${ROUTES.COMMUNITY}`}
        variant='link-color'
        size='sm'
      >
        <Icon size='20' type='arrow-left' /> Back to community
      </Button>
    </div>
  );
};
